<template>
  <div class="test_window">
    <div class="test_start" v-if="testProps.isStartPage">
      <h1>
        {{ stageInfo.type === 2 ? 'Обучающий тест по Курсу:' : 'Итоговый тест по Курсу:' }} <br />
        "{{ courseInfo.name }}"
      </h1>
      <p><b>Тема:</b> {{ stageInfo.name }}</p>
      <ul>
        <li>
          <span class="text_left">Количество вопросов:</span>
          <span class="text_right">{{ questionsList.length }}</span>
        </li>
        <li v-if="stageInfo.type === 3">
          <span class="text_left">Отведенное время (мин):</span>
          <span class="text_right">{{
            Math.floor(this.stageInfo.test_material.duration / 10) +
            '' +
            (this.stageInfo.test_material.duration % 10) +
            ':00'
          }}</span>
        </li>
        <li>
          <span class="text_left">Количество попыток:</span>
          <span class="text_right" v-if="!preview">
            {{ stageInfo.type === 2 ? testProps.attempt_number + ' /' : '' }}
            {{ stageInfo.type === 3 ? '1' : stageInfo.test_material.attempt_count }}
          </span>
          <span class="text_right" v-if="preview">
            {{ stageInfo.type === 3 ? '1' : '1/' + stageInfo.test_material.attempt_count }}
          </span>
        </li>
      </ul>
      <button :disabled="!questionsList.length" class="start_button" @click="start_test(questionsList[0], true)">
        Начать тест
      </button>
    </div>
    <div class="test_body" v-if="!testProps.isStartPage && !testProps.isEndPage">
      <div class="test_info" :class="currentQuestion.preview ? '' : 'no-image'">
        <div
          class="test_image"
          :style="{ backgroundImage: currentQuestion.preview ? 'url(' + currentQuestion.preview + ')' : '' }"
        ></div>
        <div class="test_text">
          <span
            >Вопрос: <b>{{ questions_counter + 1 }}/{{ questionsList.length }}</b></span
          >
          <span v-if="stageInfo.type === 3">
            Оставшееся время:
            <b>
              <i class="mdi mdi-timer"></i>
              {{ least_ten_min + '' + least_min + ':' + testProps.least_ten_sec + '' + testProps.least_sec }}
            </b>
          </span>
          <p class="question">{{ currentQuestion.title }}</p>
        </div>
      </div>
      <div class="test_answers">
        <p v-if="currentQuestion.answerType === 1">Выберите один из вариантов ответов:</p>
        <p v-if="currentQuestion.answerType === 2">Выберите один или несколько вариантов ответов:</p>
        <p v-if="currentQuestion.answerType === 4">Расставьте пункты в правильной последовательности:</p>
        <p v-if="currentQuestion.answerType === 5">Установите соответствие между пунктами:</p>
        <p class="true_false" v-if="currentQuestion.answerType === 6">Правда / Ложь</p>
        <p v-if="currentQuestion.answerType === 7">Распределите ответы в соответствующие списки:</p>
        <ul v-if="currentQuestion.answerType === 1">
          <li
            :class="
              isButtonPressed
                ? correctAnswer === 'answer_' + (i + 1)
                  ? 'correct'
                  : chosenAnswer === 'answer_' + (i + 1)
                  ? 'incorrect'
                  : ''
                : ''
            "
            class="answer"
            v-for="(answer, i) in currentQuestion.answersList"
            :key="i"
          >
            <b-field class="input_checkbox grey">
              <b-radio
                :disabled="isButtonPressed"
                type="is-info"
                v-model="chosenAnswer"
                :native-value="'answer_' + (i + 1)"
                @input="isAnswerChosen = true"
              >
                {{ answer.text }}
              </b-radio>
            </b-field>
          </li>
        </ul>
        <ul v-if="currentQuestion.answerType === 2">
          <li
            :class="
              isButtonPressed
                ? correctAnswers.some((el) => el === 'answer_' + (i + 1))
                  ? 'correct'
                  : chosenAnswers.some((el) => el === 'answer_' + (i + 1))
                  ? 'incorrect'
                  : ''
                : ''
            "
            class="answer"
            v-for="(answer, i) in currentQuestion.answersList"
            :key="i"
          >
            <b-field class="input_radio grey">
              <b-checkbox
                :disabled="isButtonPressed"
                type="is-info"
                v-model="chosenAnswers"
                :native-value="'answer_' + (i + 1)"
                @input="isAnswerChosen = true"
              >
                {{ answer.text }}
              </b-checkbox>
            </b-field>
          </li>
        </ul>
        <div class="open_answers_list" v-if="currentQuestion.answerType === 3">
          <ul>
            <li
              :class="
                isButtonPressed
                  ? correctAnswers.some(
                      (el) => el.toUpperCase().replace(/ /g, '') === chosenAnswer.toUpperCase().replace(/ /g, '')
                    )
                    ? 'correct'
                    : 'incorrect'
                  : ''
              "
              class="answer"
            >
              <b-field class="answer_input answer_open" type="is-info">
                <b-input
                  :disabled="isButtonPressed"
                  v-model="chosenAnswer"
                  @input="isAnswerChosen = true"
                  placeholder="Введите текст ответа"
                ></b-input>
              </b-field>
            </li>
          </ul>
          <ul
            v-if="
              isButtonPressed &&
              !correctAnswers.some(
                (el) => el.toUpperCase().replace(/ /g, '') === chosenAnswer.toUpperCase().replace(/ /g, '')
              )
            "
          >
            <li v-for="(answer, i) in currentQuestion.answersList" :key="i" class="answer correct">
              <b-field class="answer_input answer_open" type="is-info">
                <b-input :disabled="true" :value="answer.text" placeholder="Введите текст ответа"></b-input>
              </b-field>
            </li>
          </ul>
        </div>
        <draggable
          v-if="currentQuestion.answerType === 4"
          v-model="chosenAnswersList"
          @start="drag = true"
          @end="drag = false"
          class="random_answers_list"
          v-bind="dragOptions"
        >
          <div
            :class="isButtonPressed ? (element.correctIndex === i ? 'correct' : 'incorrect') : ''"
            class="random_answers_list-item"
            v-for="(element, i) in chosenAnswersList"
            :key="element.id"
          >
            {{ element.text }}

            <span v-if="isButtonPressed && !isAnswerChosenCorrect">{{ element.correctIndex + 1 }}</span>
          </div>
        </draggable>
        <div class="double_answers_list" v-if="currentQuestion.answerType === 5">
          <draggable
            v-model="firstAnswersList"
            @start="drag = true"
            @end="drag = false"
            @update="resizeAnswers"
            class="double_answers_list-left"
            v-bind="doubleDragOptions"
            :move="checkMove"
          >
            <transition-group type="transition" name="flip-list">
              <div
                v-for="(element, i) in firstAnswersList"
                :key="element.id"
                @mouseover="onHover"
                @mouseout="onOut"
                @click="isFirstChosen ? chooseSecond($event) : chooseFirst($event)"
                :class="
                  (isButtonPressed ? (element.id === secondAnswersList[i].id ? 'correct' : 'incorrect') : '') +
                  ' double_answers_list-overlay double_answers_list-overlay-1-' +
                  i
                "
              >
                <div :data-index="i" class="double_answers_list-item left" :id="'double_answers_list-item-1-' + i">
                  {{ element.text }}
                  <span v-if="isButtonPressed && !isAnswerChosenCorrect">{{ Number(element.correctIndex + 1) }}</span>
                </div>
                <div :class="'hover-row hover-row-1-' + i"></div>
              </div>
            </transition-group>
          </draggable>
          <draggable
            v-model="secondAnswersList"
            @start="drag = true"
            @end="drag = false"
            @update="resizeAnswers"
            class="double_answers_list-right"
            v-bind="doubleDragOptions"
            :move="checkMove"
          >
            <transition-group type="transition" name="flip-list">
              <div
                v-for="(element, i) in secondAnswersList"
                :key="element.id"
                @mouseover="onHover"
                @mouseout="onOut"
                @click="isFirstChosen ? chooseSecond($event) : chooseFirst($event)"
                :class="
                  (isButtonPressed ? (element.id === firstAnswersList[i].id ? 'correct' : 'incorrect') : '') +
                  ' double_answers_list-overlay double_answers_list-overlay-2-' +
                  i
                "
              >
                <div :data-index="i" class="double_answers_list-item right" :id="'double_answers_list-item-2-' + i">
                  {{ element.text2 }}
                  <span v-if="isButtonPressed && !isAnswerChosenCorrect">{{ Number(element.correctIndex + 1) }}</span>
                </div>
                <div :class="'hover-row hover-row-2-' + i"></div>
              </div>
            </transition-group>
          </draggable>
        </div>
        <ul class="true_false" v-if="currentQuestion.answerType === 6">
          <li
            :class="isButtonPressed ? (correctAnswers[i] === chosenAnswers[i] ? 'correct' : 'incorrect') : ''"
            class="answer"
            v-for="(answer, i) in currentQuestion.answersList"
            :key="i"
          >
            <p>
              <span>{{ answer.text }}</span>
            </p>
            <b-field class="input_checkbox grey true">
              <b-radio
                :disabled="isButtonPressed"
                type="is-info"
                v-model="chosenAnswers[i]"
                :native-value="'true'"
                @input="isAnswerChosen = true"
              ></b-radio>
            </b-field>
            <b-field class="input_checkbox grey false">
              <b-radio
                :disabled="isButtonPressed"
                type="is-info"
                v-model="chosenAnswers[i]"
                :native-value="'false'"
                @input="isAnswerChosen = true"
              ></b-radio>
            </b-field>
          </li>
        </ul>
        <div class="lists" v-if="currentQuestion.answerType === 7">
          <draggable
            v-model="currentQuestion.answersList"
            @start="drag = true"
            @end="drag = false"
            class="lists-answers"
            v-bind="dragOptions"
          >
            <transition-group class="lists-answers">
              <div
                :class="isButtonPressed ? (element.correctIndex === i ? 'correct' : 'incorrect') : ''"
                class="lists-answers__item"
                v-for="(element, i) in currentQuestion.answersList"
                :key="element.id"
              >
                {{ element.text }}
              </div>
            </transition-group>
          </draggable>
          <div class="lists-item" v-for="(column, j) in currentQuestion.columnsList" :key="j">
            <p>{{ column.text }}</p>
            <draggable
              :list="chosenAnswersList[j].list"
              @start="drag = true"
              @end="drag = false"
              :class="chosenAnswersList[j].list.length ? 'lists-answers' : 'empty lists-answers'"
              v-bind="dragOptions"
            >
              <div
                :class="isButtonPressed ? (element.correctID === column.id ? 'correct' : 'incorrect') : ''"
                class="lists-answers__item"
                v-for="(element, i) in chosenAnswersList[j].list"
                :key="element.id + i"
              >
                {{ element.text }}
                <!-- <span v-if="isButtonPressed && !isAnswerChosenCorrect">{{ element.correctIndex + 1 }}</span> -->
              </div>
            </draggable>
          </div>
        </div>
      </div>
    </div>
    <div class="test-end" v-if="testProps.isEndPage">
      <div class="test-end__header" :class="isTestPassed ? 'success' : 'fail'">
        {{
          isTestEdited ? 'Тест был изменен' : isTestPassed ? 'Поздравляем! Вы успешно прошли тест' : 'Тест не пройден'
        }}
      </div>
      <div class="test-end__body">
        <div class="test-end__result">
          <p>
            <b>{{ stageInfo.type === 2 ? 'Обучающий тест по Курсу:' : 'Итоговый тест по Курсу:' }}</b>
            <br />
            "{{ courseInfo.name }}"
          </p>
          <p>
            <b>Тема:</b>
            <br />
            {{ stageInfo.name }}
          </p>
          <ul class="left">
            <li>
              <span class="left">Ваш результат:</span>
              <b>{{ correct_answers }} / {{ questionsList.length }} ({{ testResult }}%)</b>
            </li>
            <li v-if="stageInfo.type === 3">
              <span class="left">Затраченное время (мин):</span>
              <b>{{ testProps.ten_min + '' + testProps.min + ':' + testProps.ten_sec + '' + testProps.sec }}</b>
            </li>
            <li>
              <span class="left">Количество попыток:</span>
              <b class="text_right" v-if="!preview">
                {{ stageInfo.type === 2 ? testProps.attempt_number + ' /' : '' }}
                {{ stageInfo.type === 3 ? '1' : stageInfo.test_material.attempt_count }}
              </b>
              <b class="text_right" v-if="preview">
                {{ stageInfo.type === 3 ? '1' : '1/' + stageInfo.test_material.attempt_count }}
              </b>
            </li>
          </ul>
        </div>
        <div class="test-end__buttons">
          <div
            class="test-end__button restart"
            v-if="
              (testProps.attempt_number != stageInfo.test_material.attempt_count && stageInfo.type === 2) ||
              isTestEdited
            "
          >
            <button @click="$emit('reload-test')">Начать тест заново</button>
            <p>
              У вас
              {{
                $counter(
                  preview
                    ? stageInfo.test_material.attempt_count
                    : stageInfo.test_material.attempt_count - testProps.attempt_number,
                  [' попытка', ' попытки', ' попыток'],
                  ['осталась ', 'осталось ', 'осталось ']
                )
              }}
            </p>
          </div>
          <div class="test-end__button mistakes">
            <button @click="start_mistakes">Работа над ошибками</button>
            <p>Вы пройдете тест заново с отображением правильных и неправильных ответов на вопросы</p>
          </div>
          <div class="test-end__button protocol" v-if="userRole === 'user' && !isTestEdited">
            <button class="proto_button" @click="download">Скачать протокол</button>
            <p>Скачать протокол с результатами вашего тестирования</p>
          </div>
        </div>
      </div>
    </div>
    <div class="controls" v-if="testProps.isTestStarted">
      <div class="controls_results_block">
        <ul class="results-list left" v-if="isButtonPressed">
          <li class="incorrect">Неверный ответ</li>
          <li class="correct">Верный ответ</li>
        </ul>
        <!-- <button class="controls_tab" disabled>Описание урока</button>
                <button class="controls_tab" disabled>Доступные курсы</button> -->
        <div class="controls_buttons_block" v-if="!testProps.isStartPage && !testProps.isEndPage">
          <div class="direction_buttons" v-if="stageInfo.type != 3 && !isMistakes">
            <button
              class="controls_button next_button"
              @click="check_answer()"
              v-if="!isButtonPressed"
              :disabled="!isAnswerChosen"
            >
              Подтвердить
            </button>
            <button
              class="controls_button next_button"
              @click="reload_test(questionsList[questions_counter + 1], true)"
              v-if="questions_counter < questionsList.length - 1 && isButtonPressed"
            >
              Далее
            </button>
            <button
              class="controls_button end_button"
              @click="end_test()"
              v-if="questions_counter === questionsList.length - 1 && isButtonPressed"
            >
              Завершить тест
            </button>
          </div>
          <div class="direction_buttons" v-if="stageInfo.type === 3 && !isMistakes">
            <button
              class="controls_button back_button"
              @click="reload_test(questionsList[questions_counter - 1], false)"
              v-if="questions_counter"
            >
              Назад
            </button>
            <button
              class="controls_button next_button"
              @click="
                check_answer()
                reload_test(questionsList[questions_counter + 1], true)
              "
              v-if="questions_counter < questionsList.length - 1"
            >
              Далее
            </button>
            <button
              class="controls_button end_button"
              @click="
                check_answer().then((val) => {
                  end_test()
                })
              "
              v-if="questions_counter === questionsList.length - 1"
              :disabled="!isAnswerChosen"
            >
              Завершить тест
            </button>
          </div>
          <div class="direction_buttons" v-if="isMistakes">
            <button
              class="controls_button back_button"
              @click="
                reload_test(resultsList[questions_counter - 1], false)
                check_answer()
              "
              v-if="questions_counter"
            >
              Назад
            </button>
            <button
              class="controls_button next_button"
              @click="
                reload_test(resultsList[questions_counter + 1], true)
                check_answer()
              "
              v-if="questions_counter < questionsList.length - 1"
              :disabled="!isAnswerChosen"
            >
              Далее
            </button>
            <button class="controls_button end_button" @click="end_mistakes()" :disabled="!isAnswerChosen">
              Посмотреть результаты
            </button>
          </div>
        </div>
      </div>
      <div class="controls_results_block">
        <ul class="results-list right" v-if="isButtonPressed">
          <li class="title" v-if="!isAnswerChosenCorrect"><b>Комментарий:</b> {{ currentQuestion.comment }}</li>
          <li class="link" v-if="currentQuestion.lessonLinkType === 0">
            <router-link :to="`/my-courses/${currentQuestion.lessonLink}?courseId=${courseInfo.id}`" target="_blank"
              >Ссылка на урок</router-link
            >
          </li>
          <li class="link" v-if="currentQuestion.lessonLinkType === 1">
            <a :href="currentQuestion.lessonLink" target="_blank">Ссылка на внешний ресурс</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { toastDanger } from '@/lib/toastCfg'

export default {
  components: {
    draggable
  },
  data() {
    return {
      correctAnswer: '',
      correctAnswers: [],
      isAnswerChosen: true,
      isFirstChosen: false,
      isSecondChosen: false,
      isButtonPressed: false,
      firstChosenElem: null,
      secondChosenElem: null,
      isAnswerChosenCorrect: false,
      isMistakes: false,
      chosenAnswer: '',
      chosenAnswers: [],
      chosenAnswersList: [],
      firstAnswersList: [],
      secondAnswersList: [],
      isTestPassed: false,
      isTestEdited: false,
      testTimer: null,
      questions_counter: -1,
      all_answers: [],
      correct_answers: 0,
      currentQuestion: {
        image: ''
      },
      least_min: 0,
      least_ten_min: 1,
      testResult: null,
      resultsList: [],
      user_test_attempt_id: 0
    }
  },
  props: {
    testProps: {
      default: () => {},
      type: Object
    },
    stageInfo: {
      default: () => {},
      type: Object
    },
    preview: {
      default: () => false,
      type: Boolean
    },
    isLeaveModalOpen: {
      default: () => false
    },
    courseInfo: {
      default: () => {},
      type: Object
    }
  },
  computed: {
    questionsList() {
      let questions = []
      if (this.stageInfo.type === 2) {
        if (this.stageInfo.test_material.content.length) {
          questions = JSON.parse(this.stageInfo.test_material.content)
        }
      } else if (this.stageInfo.type === 3) {
        if (this.stageInfo.test_material.content.length) {
          let finalQuestions = JSON.parse(this.stageInfo.test_material.content)
          finalQuestions.forEach((theme) => {
            let shuffled = theme.sort(() => 0.5 - Math.random())
            let selected = shuffled.slice(0, this.stageInfo.test_material.questions_per_theme)
            selected.forEach((question) => {
              questions.push(question)
            })
          })
        }
      }
      return questions.sort(() => 0.5 - Math.random())
      // return questions.slice(0, 5)
    },
    userRole() {
      return this.$store.state.auth.role[0]
    },
    profileInfo() {
      return this.$store.state.auth.currentUser
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: this.isButtonPressed ? true : false,
        ghostClass: 'ghost'
      }
    },
    doubleDragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: true,
        ghostClass: 'ghost'
      }
    },
    courseId() {
      return Number(this.$route.query.courseId)
    },
    stageId() {
      return Number(this.$route.params.id)
    },
    rightCoursesList() {
      return this.$store.state.courses.userRightCoursesList.courses
    },
    currentCourse() {
      const course = this.rightCoursesList.find((el) => el.id === Number(this.courseId))
      if (course) {
        return course
      }
      return {
        name: '',
        stages: []
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.testTimer)
  },
  watch: {
    isLeaveModalOpen: function (newVal) {
      let cId = this.courseId
      let sId = this.stageId
      let uId = this.user_test_attempt_id
      if (newVal === 'home!auth') {
        this.testLeaving(cId, sId, uId)
        return
      }
      if (newVal) {
        this.$nextTick(() => {
          document.getElementById('confirm-leave-btn').addEventListener('click', () => {
            this.testLeaving(cId, sId, uId)
          })
        })
      }
    }
  },
  methods: {
    loadCourses() {
      this.$axios2
        .get('courses')
        .then((resp) => {
          this.$store.commit('setUserRightCoursesList', { list: resp.data })
        })
        .catch(this.$errorToast)
    },
    onOut() {
      if (!this.firstChosenElem || this.isSecondChosen) return
      let firstEl = document.querySelector('.hover-row-1-' + this.firstChosenElem.dataset.index)
      let secondEl = document.querySelector('.hover-row-2-' + this.firstChosenElem.dataset.index)
      firstEl.style.width = 50 + 'px'
      secondEl.style.width = 50 + 'px'
      firstEl.style.transform = 'rotate(0)'
      secondEl.style.transform = 'rotate(0)'
    },
    onHover(event) {
      if (!this.firstChosenElem || this.isSecondChosen) return
      let element = event.target
      let parent = event.target.parentElement
      if (element.className.includes('overlay')) {
        element = event.target.firstChild
        parent = event.target
      }
      if (element.id === this.firstChosenElem.id) return
      if (element.classList.contains('left') && this.firstChosenElem.classList.contains('left')) return
      if (element.classList.contains('right') && this.firstChosenElem.classList.contains('right')) return

      this.calcRow(element, parent)
    },
    calcRow(element, parent) {
      if (!this.firstChosenElem) return
      let row
      let elemParams = parent.getBoundingClientRect()
      let chosenElemParams = this.firstChosenElem.parentElement.getBoundingClientRect()
      let width, height, size, deg
      if (element.classList.contains('left')) {
        document.querySelector('.hover-row-1-' + this.firstChosenElem.dataset.index).style.width = 0
        row = document.querySelector('.hover-row-2-' + this.firstChosenElem.dataset.index)
        width = Math.abs(elemParams.right - chosenElemParams.left)
        // row.style.left = (chosenElemParams.left) + 'px'
      } else if (element.classList.contains('right')) {
        document.querySelector('.hover-row-2-' + this.firstChosenElem.dataset.index).style.width = 0
        row = document.querySelector('.hover-row-1-' + this.firstChosenElem.dataset.index)
        width = Math.abs(elemParams.left - chosenElemParams.right)
        // row.style.left = (chosenElemParams.right) + 'px'
      }
      if (!row) return
      height = elemParams.top + elemParams.height / 2 - (chosenElemParams.top + chosenElemParams.height / 2)
      size = Math.sqrt(width * width + Math.abs(height * height))
      deg = 90 - (180 / Math.PI) * Math.atan2(width, Math.abs(height))

      row.style.width = size + 'px'
      row.style.transform =
        'rotate(' + deg * (height < 0 ? -1 : 1) * (element.classList.contains('left') ? -1 : 1) + 'deg)'
      // row.style.top = (2 + chosenElemParams.top + window.scrollY + (this.firstChosenElem.parentElement.offsetHeight/2)) + 'px'
    },
    callCalc(element, parent, sec) {
      return new Promise((resolve) => {
        let ms = 0
        let time = setInterval(() => {
          if (ms == sec) {
            clearInterval(time)
            resolve()
          }
          ms += 1
          this.calcRow(element, parent)
        }, 1)
      })
    },
    chooseFirst(event) {
      let element = event.target
      if (this.isMistakes || this.isButtonPressed || event.target.className.includes('hover-row')) return
      if (element.className.includes('overlay')) element = event.target.firstChild
      this.isFirstChosen = true
      this.firstChosenElem = element
      element.parentElement.classList.add('focus')
      document.onkeydown = (e) => {
        if (e.keyCode === 27) {
          this.resizeAnswers().then(() => {
            this.onOut()
            this.cancelChoose()
          })
        }
      }
    },
    chooseSecond(event) {
      let element = event.target
      if (element.className.includes('overlay')) element = event.target.firstChild
      if (!this.firstChosenElem || this.isSecondChosen || event.target.className.includes('hover-row')) return
      if (element.id === this.firstChosenElem.id) return
      if (element.classList.contains('left') && this.firstChosenElem.classList.contains('left')) return
      if (element.classList.contains('right') && this.firstChosenElem.classList.contains('right')) return
      this.isSecondChosen = true
      this.secondChosenElem = element
      element.parentElement.classList.add('focus')

      let array = []
      if (element.classList.contains('left')) {
        array = this.firstAnswersList
      } else if (element.classList.contains('right')) {
        array = this.secondAnswersList
      }
      let cutElem1 = array[element.dataset.index]
      let cutElem2 = array[this.firstChosenElem.dataset.index]
      array.splice(element.dataset.index, 1, cutElem2)
      array.splice(this.firstChosenElem.dataset.index, 1, cutElem1)

      this.callCalc(element, element.parentElement, 50).then(() => {
        this.resizeAnswers().then(() => {
          this.callCalc(element, element.parentElement, 70).then(() => {
            this.cancelChoose()
          })
        })
      })
    },
    cancelChoose() {
      if (this.secondChosenElem) {
        let secEl = document.getElementById(this.secondChosenElem.id)
        secEl.parentElement.classList.remove('focus')
      }
      if (this.firstChosenElem) {
        let firstEl = document.getElementById(this.firstChosenElem.id)
        firstEl.parentElement.classList.remove('focus')
      }
      document.onkeydown = null
      this.isFirstChosen = false
      this.isSecondChosen = false
      this.firstChosenElem = null
      this.secondChosenElem = null
      document.onwheel = null
    },
    download() {
      this.$axios
        .post('protocol', {
          commission_id: null,
          user_test_attempt_id: this.user_test_attempt_id
        })
        .then((resp) => {
          window.open(resp.data.data.protocol_url)
        })
        .catch(this.$errorToast)
    },
    testLeaving(cId, sId, uId) {
      this.testProps.isTestStarted = false
      if (this.chosenAnswer.length) {
        this.all_answers.push(this.chosenAnswer)
      } else if (this.chosenAnswers.length) {
        this.all_answers.push(this.chosenAnswers)
      }
      this.isAnswerCorrect()
      clearInterval(this.testTimer)
      window.onbeforeunload = ''
      this.testResult = ((this.correct_answers / this.questionsList.length) * 100).toFixed(1)
      if (this.userRole === 'user') {
        this.$axios2
          .post('courses/' + cId + '/stages/' + sId + '/test/' + uId, {
            time:
              this.testProps.ten_min + '' + this.testProps.min + ':' + this.testProps.ten_sec + '' + this.testProps.sec,
            question_count: this.questionsList.length,
            correct_answers_count: this.correct_answers,
            status: this.testResult >= this.stageInfo.test_material.percent ? 1 : 0,
            content: JSON.stringify(this.resultsList)
          })
          .catch(this.$errorToast)
      }
    },
    tick() {
      this.testProps.sec++
      if (this.testProps.sec > 9) {
        this.testProps.sec = 0
        this.testProps.ten_sec++
        if (this.testProps.ten_sec >= 6) {
          this.testProps.ten_sec = 0
          this.testProps.min++
          if (this.testProps.min > 9) {
            this.testProps.min = 0
            this.testProps.ten_min++
          }
        }
      }
      this.testProps.least_sec--
      if (
        this.testProps.least_sec === 0 &&
        this.testProps.least_ten_sec === 0 &&
        this.least_min === 0 &&
        this.least_ten_min === 0
      ) {
        this.end_time()
        this.$buefy.toast.open(toastDanger('Время вышло'))
      }
      if (this.testProps.least_sec < 0) {
        this.testProps.least_sec = 9
        this.testProps.least_ten_sec--
        if (this.testProps.least_ten_sec < 0) {
          this.testProps.least_ten_sec = 5
          this.least_min--
          if (this.least_min < 0) {
            this.least_min = 9
            this.least_ten_min--
          }
        }
      }
    },
    async resizeAnswers() {
      for (let i = 0; i < this.firstAnswersList.length; i++) {
        let item1 = document.querySelector('.double_answers_list-overlay-1-' + i)
        let item2 = document.querySelector('.double_answers_list-overlay-2-' + i)
        if (item1.firstChild.offsetHeight >= item2.firstChild.offsetHeight) {
          item1.style.height = item1.firstChild.offsetHeight + 'px'
          item2.style.height = item1.firstChild.offsetHeight + 'px'
        } else {
          item1.style.height = item2.firstChild.offsetHeight + 'px'
          item2.style.height = item2.firstChild.offsetHeight + 'px'
        }
      }
    },
    start_test(info) {
      if (
        (this.stageInfo.user_test_attempts &&
          this.stageInfo.user_test_attempts.length != this.stageInfo.test_material.attempt_count) ||
        !this.stageInfo.user_test_attempts ||
        this.userRole === 'admin' ||
        this.userRole === 'leader' ||
        this.userRole === 'methodist'
      ) {
        if (!this.$browserDetect.isIE) {
          window.Echo.private(`test_material.${this.stageInfo.test_material.id}`).listen('TestMaterialUpdated', () => {
            this.test_edited()
          })
        }
        if (this.userRole === 'user') {
          this.$axios2
            .get('courses/' + this.courseId + '/stages/' + this.stageId + '/test')
            .then((resp) => {
              this.user_test_attempt_id = resp.data.user_test_attempt_id
            })
            .catch(this.$errorToast)
        }
        if (!this.preview) {
          window.onbeforeunload = function () {
            return 'Вы собираетесь покинуть страницу? Возможно, внесенные изменения не сохранятся!'
          }
        }
        this.testProps.attempt_number += 1
        this.isAnswerChosen = true
        this.isFirstChosen = false
        this.isSecondChosen = false
        this.firstChosenElem = null
        this.secondChosenElem = null
        this.isButtonPressed = false
        this.isAnswerChosenCorrect = false
        this.testProps.isTestStarted = true
        this.resultsList = []
        this.all_answers = []
        this.correctAnswer = ''
        this.chosenAnswer = ''
        this.correctAnswers = []
        this.chosenAnswers = []
        if (info.answerType === 4) {
          this.chosenAnswersList = info.answersList.sort(() => {
            return 0.5 - Math.random()
          })
        } else if (info.answerType === 7) {
          this.chosenAnswersList = []
          info.columnsList.forEach((column) => {
            this.chosenAnswersList.push({
              id: column.id,
              text: column.text,
              list: []
            })
          })
        } else {
          this.chosenAnswersList = []
        }
        if (info.answerType === 5) {
          this.firstAnswersList = info.answersList
          this.secondAnswersList = []
          info.answersList.forEach((el) => {
            this.secondAnswersList.push(el)
          })
          this.secondAnswersList.sort(() => {
            return 0.5 - Math.random()
          })
        } else {
          this.firstAnswersList = []
          this.secondAnswersList = []
        }
        this.testProps.isEndPage = false
        this.questions_counter = -1
        this.correct_answers = 0
        this.testProps.sec = 0
        this.testProps.ten_sec = 0
        this.testProps.min = 0
        this.testProps.ten_min = 0
        this.testProps.least_sec = 0
        this.testProps.least_ten_sec = 0
        this.least_min = this.stageInfo.test_material.duration % 10
        this.least_ten_min = Math.floor(this.stageInfo.test_material.duration / 10)
        if (this.stageInfo.type === 3) {
          this.testTimer = setInterval(this.tick, 1000)
        }
        this.currentQuestion = info
        this.testProps.isStartPage = false
        this.questions_counter++
        if (info.answerType === 7) {
          this.currentQuestion.answersList.sort(() => {
            return 0.5 - Math.random()
          })
        }
        if (info.answerType === 5) {
          this.$nextTick(() => {
            this.resizeAnswers()
          })
        }
      } else {
        this.$buefy.toast.open(toastDanger('Кол-во попыток на прохождение теста исчерпано'))
      }
    },
    start_mistakes() {
      this.isMistakes = true
      this.testProps.isTestStarted = true
      this.testProps.isEndPage = false
      this.isButtonPressed = true
      this.questions_counter = 0
      this.$nextTick(() => {
        this.reload_test(this.resultsList[this.questions_counter], true, true)
        this.check_answer()
      })
    },
    end_time() {
      if (!this.$browserDetect.isIE) {
        window.Echo.leave(`test_material.${this.stageInfo.test_material.id}`)
      }
      this.testProps.isTestStarted = false
      this.isTestEdited = false
      if (this.chosenAnswer.length) {
        this.all_answers.push(this.chosenAnswer)
      } else if (this.chosenAnswers.length) {
        this.all_answers.push(this.chosenAnswers)
      } else if (this.chosenAnswersList.length) {
        this.all_answers.push(this.chosenAnswersList)
      } else if (this.firstAnswersList.length && this.secondAnswersList.length) {
        this.all_answers.push({
          first: this.firstAnswersList,
          second: this.secondAnswersList
        })
      }
      this.isAnswerCorrect()
      clearInterval(this.testTimer)
      this.testProps.isEndPage = true
      window.onbeforeunload = ''
      this.testResult = ((this.correct_answers / this.questionsList.length) * 100).toFixed(1)
      if (this.testResult > this.stageInfo.test_material.percent) {
        this.isTestPassed = true
      } else {
        this.isTestPassed = false
      }
      if (this.userRole === 'user') {
        this.$axios2
          .post('courses/' + this.courseId + '/stages/' + this.stageId + '/test/' + this.user_test_attempt_id, {
            time:
              this.testProps.ten_min + '' + this.testProps.min + ':' + this.testProps.ten_sec + '' + this.testProps.sec,
            question_count: this.questionsList.length,
            correct_answers_count: this.correct_answers,
            status: this.testResult >= this.stageInfo.test_material.percent ? 1 : 0,
            content: JSON.stringify(this.resultsList)
          })
          .catch(this.$errorToast)
      }
    },
    end_test() {
      if (
        this.all_answers.every((el) => el.length || (el.first && el.first.length && el.second && el.second.length)) &&
        (this.chosenAnswer.length ||
          this.chosenAnswers.length ||
          this.chosenAnswersList.length ||
          (this.firstAnswersList.length && this.secondAnswersList.length))
      ) {
        if (!this.$browserDetect.isIE) {
          window.Echo.leave(`test_material.${this.stageInfo.test_material.id}`)
        }
        this.testProps.isTestStarted = false
        this.isTestEdited = false
        // if (this.chosenAnswer.length) {
        //    this.all_answers.push(this.chosenAnswer)
        // } else if (this.chosenAnswers.length) {
        //    this.all_answers.push(this.chosenAnswers)
        // } else if (this.chosenAnswersList.length) {
        //    this.all_answers.push(this.chosenAnswersList)
        // } else if (this.firstAnswersList.length && this.secondAnswersList.length) {
        //    this.all_answers.push({
        //       first: this.firstAnswersList,
        //       second: this.secondAnswersList
        //    })
        // }
        if (this.currentQuestion.answerType === 1 || this.currentQuestion.answerType === 3) {
          this.all_answers.push(this.chosenAnswer)
        } else if (this.currentQuestion.answerType === 2 || this.currentQuestion.answerType === 6) {
          this.all_answers.push(this.chosenAnswers)
        } else if (this.currentQuestion.answerType === 4 || this.currentQuestion.answerType === 7) {
          this.all_answers.push(this.chosenAnswersList)
        } else if (this.currentQuestion.answerType === 5) {
          this.all_answers.push({
            first: this.firstAnswersList,
            second: this.secondAnswersList
          })
        }
        this.isAnswerCorrect()
        clearInterval(this.testTimer)
        this.testProps.isEndPage = true
        window.onbeforeunload = ''
        this.testResult = ((this.correct_answers / this.questionsList.length) * 100).toFixed(1)
        if (this.testResult >= this.stageInfo.test_material.percent) {
          this.isTestPassed = true
        } else {
          this.isTestPassed = false
        }
        if (this.userRole === 'user') {
          this.$axios2
            .post('courses/' + this.courseId + '/stages/' + this.stageId + '/test/' + this.user_test_attempt_id, {
              time:
                this.testProps.ten_min +
                '' +
                this.testProps.min +
                ':' +
                this.testProps.ten_sec +
                '' +
                this.testProps.sec,
              question_count: this.questionsList.length,
              correct_answers_count: this.correct_answers,
              status: this.testResult >= this.stageInfo.test_material.percent ? 1 : 0,
              content: JSON.stringify(this.resultsList)
            })
            .then(() => {
              let currentStage = this.currentCourse.stages.find((stage) => stage.id === this.stageId)
              if (currentStage.passed) return
              this.$axios2
                .post('/courses/' + this.courseId + '/stages/' + this.stageId + '/pass')
                .then(this.loadCourses)
            })
            .catch(this.$errorToast)
        }
      } else {
        this.$buefy.toast.open(toastDanger('Вы ответили не на все вопросы'))
      }
    },
    end_mistakes() {
      this.isMistakes = false
      this.testProps.isTestStarted = false
      this.testProps.isEndPage = true
      this.isButtonPressed = false
    },
    test_edited() {
      if (!this.$browserDetect.isIE) {
        window.Echo.leave(`test_material.${this.stageInfo.test_material.id}`)
      }
      this.testProps.isTestStarted = false
      clearInterval(this.testTimer)
      this.testProps.isEndPage = true
      window.onbeforeunload = ''
      this.isTestPassed = false
      this.isTestEdited = true
    },
    reloadNext() {
      if (
        this.questionsList[this.questions_counter].answerType === 1 ||
        this.questionsList[this.questions_counter].answerType === 3
      ) {
        this.all_answers[this.questions_counter] = this.chosenAnswer
      } else if (
        this.questionsList[this.questions_counter].answerType === 2 ||
        this.questionsList[this.questions_counter].answerType === 6
      ) {
        this.all_answers[this.questions_counter] = this.chosenAnswers
      } else if (
        this.questionsList[this.questions_counter].answerType === 4 ||
        this.questionsList[this.questions_counter].answerType === 7
      ) {
        this.all_answers[this.questions_counter] = this.chosenAnswersList
      } else if (this.questionsList[this.questions_counter].answerType === 5) {
        this.all_answers[this.questions_counter] = {
          first: this.firstAnswersList,
          second: this.secondAnswersList
        }
      }
      // this.chosenAnswer = ''
      // this.chosenAnswers = []
      // if (info.answerType === 7) {
      //    this.chosenAnswersList = []
      //    info.columnsList.forEach((column) => {
      //       this.chosenAnswersList.push({
      //          id: column.id,
      //          text: column.text,
      //          list: []
      //       })
      //    })
      // } else {
      //    this.chosenAnswersList = []
      // }
      // this.firstAnswersList = []
      // this.secondAnswersList = []
    },
    reloadBack() {
      this.isAnswerChosen = true
      this.reloadNext()
      this.questions_counter--
      if (
        this.questionsList[this.questions_counter].answerType === 1 ||
        this.questionsList[this.questions_counter].answerType === 3
      ) {
        this.chosenAnswer = this.all_answers[this.questions_counter]
      } else if (
        this.questionsList[this.questions_counter].answerType === 2 ||
        this.questionsList[this.questions_counter].answerType === 6
      ) {
        this.chosenAnswers = this.all_answers[this.questions_counter]
      } else if (
        this.questionsList[this.questions_counter].answerType === 4 ||
        this.questionsList[this.questions_counter].answerType === 7
      ) {
        this.chosenAnswersList = this.all_answers[this.questions_counter]
      } else if (this.questionsList[this.questions_counter].answerType === 5) {
        this.firstAnswersList = this.all_answers[this.questions_counter].first
        this.secondAnswersList = this.all_answers[this.questions_counter].second
        this.$nextTick(() => {
          this.resizeAnswers()
        })
      }
    },
    reload_test(info, next, disableIncrement = false) {
      //this.isAnswerChosen = false
      if (!this.isMistakes) {
        this.isButtonPressed = false
      }
      this.isAnswerChosenCorrect = false
      if (!disableIncrement) {
        if (next) {
          this.reloadNext()
          this.questions_counter++
        } else {
          this.reloadBack()
        }
      }
      if (info.answerType === 7 && !this.isMistakes) {
        info.answersList.sort(() => {
          return 0.5 - Math.random()
        })
      }
      this.currentQuestion = info
      if (
        this.questionsList[this.questions_counter].answerType === 1 ||
        this.questionsList[this.questions_counter].answerType === 3
      ) {
        if (this.all_answers[this.questions_counter]) {
          this.isAnswerChosen = true
          this.chosenAnswer = this.all_answers[this.questions_counter]
        } else {
          this.chosenAnswer = ''
        }
      } else if (
        this.questionsList[this.questions_counter].answerType === 2 ||
        this.questionsList[this.questions_counter].answerType === 6
      ) {
        if (this.all_answers[this.questions_counter]) {
          this.isAnswerChosen = true
          this.chosenAnswers = this.all_answers[this.questions_counter]
        } else {
          this.chosenAnswers = []
        }
      } else if (
        this.questionsList[this.questions_counter].answerType === 4 ||
        this.questionsList[this.questions_counter].answerType === 7
      ) {
        if (this.all_answers[this.questions_counter]) {
          this.isAnswerChosen = true
          this.chosenAnswersList = this.all_answers[this.questions_counter]
        } else if (info.answerType === 7) {
          this.chosenAnswersList = []
          info.columnsList.forEach((column) => {
            this.chosenAnswersList.push({
              id: column.id,
              text: column.text,
              list: []
            })
          })
        } else {
          this.chosenAnswersList = info.answersList.sort(() => {
            return 0.5 - Math.random()
          })
        }
      } else if (this.questionsList[this.questions_counter].answerType === 5) {
        if (this.all_answers[this.questions_counter]) {
          this.isAnswerChosen = true
          this.firstAnswersList = this.all_answers[this.questions_counter].first
          this.secondAnswersList = this.all_answers[this.questions_counter].second
        } else {
          this.firstAnswersList = info.answersList
          this.secondAnswersList = []
          info.answersList.forEach((el) => {
            this.secondAnswersList.push(el)
          })
          this.secondAnswersList.sort(() => {
            return 0.5 - Math.random()
          })
        }
        this.$nextTick(() => {
          this.resizeAnswers()
        })
      }
    },
    check_answer() {
      this.correctAnswers = []
      this.correctAnswer = ''
      this.isAnswerChosenCorrect = false
      return new Promise((resolve) => {
        if (this.currentQuestion.answerType === 1) {
          if (this.chosenAnswer.length) {
            if (this.stageInfo.type === 2) {
              this.isButtonPressed = true
            }
            for (let q = 0; q < this.currentQuestion.answersList.length; q++) {
              if (this.currentQuestion.answersList[q].correct) {
                this.correctAnswer = 'answer_' + (q + 1)
                if (this.chosenAnswer === this.correctAnswer) {
                  this.isAnswerChosenCorrect = true
                }
              }
            }
            resolve(true)
          } else {
            this.isButtonPressed = false
            this.isAnswerChosen = false
            this.$buefy.toast.open(toastDanger('Вы не ответили на вопрос'))
          }
        } else if (this.currentQuestion.answerType === 2) {
          let total_corrects_count = 0
          let current_corrects_count = 0
          if (this.chosenAnswers.length) {
            if (this.stageInfo.type === 2) {
              this.isButtonPressed = true
            }
            for (let i = 0; i < this.currentQuestion.answersList.length; i++) {
              if (this.currentQuestion.answersList[i].correct) {
                this.correctAnswers.push('answer_' + (i + 1))
                total_corrects_count++
                if (this.chosenAnswers.some((el) => el === 'answer_' + (i + 1))) current_corrects_count++
              }
            }
            if (current_corrects_count === total_corrects_count && this.chosenAnswers.length === total_corrects_count) {
              this.isAnswerChosenCorrect = true
            }
            resolve(true)
          } else {
            this.isButtonPressed = false
            this.isAnswerChosen = false
            this.$buefy.toast.open(toastDanger('Вы не ответили на вопрос'))
          }
        } else if (this.currentQuestion.answerType === 3) {
          if (this.chosenAnswer.length) {
            if (this.stageInfo.type === 2) {
              this.isButtonPressed = true
            }
            for (let k = 0; k < this.currentQuestion.answersList.length; k++) {
              this.correctAnswers.push(this.currentQuestion.answersList[k].text.toUpperCase().replace(/ /g, ''))
            }
            if (this.correctAnswers.some((el) => el === this.chosenAnswer.toUpperCase().replace(/ /g, ''))) {
              this.isAnswerChosenCorrect = true
            }
            resolve(true)
          } else {
            this.isButtonPressed = false
            this.isAnswerChosen = false
            this.$buefy.toast.open(toastDanger('Вы не ответили на вопрос'))
          }
        } else if (this.currentQuestion.answerType === 4) {
          if (this.stageInfo.type === 2) {
            this.isButtonPressed = true
          }
          if (this.chosenAnswersList.every((finalAnswer, i) => finalAnswer.correctIndex === i)) {
            this.isAnswerChosenCorrect = true
          }
          resolve(true)
        } else if (this.currentQuestion.answerType === 5) {
          if (this.stageInfo.type === 2) {
            this.isButtonPressed = true
          }
          if (this.firstAnswersList.every((firstAnswer, i) => firstAnswer.id === this.secondAnswersList[i].id)) {
            this.isAnswerChosenCorrect = true
          }
          resolve(true)
        } else if (this.currentQuestion.answerType === 6) {
          let checkTrueFalse = (array) => {
            let chosen = 0
            for (let i = 0; i < array.length; i++) {
              if (!array[i]) continue
              chosen += 1
            }
            return chosen === array.length ? true : false
          }
          if (
            this.chosenAnswers.length === this.currentQuestion.answersList.length &&
            checkTrueFalse(this.chosenAnswers)
          ) {
            if (this.stageInfo.type === 2) {
              this.isButtonPressed = true
            }
            for (let i = 0; i < this.currentQuestion.answersList.length; i++) {
              this.correctAnswers[i] = this.currentQuestion.answersList[i].correctAnswer
            }
            if (
              this.correctAnswers.every((answer, i) => {
                return answer === this.chosenAnswers[i]
              })
            ) {
              this.isAnswerChosenCorrect = true
            }
            resolve(true)
          } else {
            this.isButtonPressed = false
            this.isAnswerChosen = false
            this.$buefy.toast.open(toastDanger('Вы не ответили на вопрос'))
          }
        } else if (this.currentQuestion.answerType === 7) {
          if (this.currentQuestion.answersList.length) {
            if (!this.isMistakes) {
              this.$buefy.toast.open(toastDanger('Вы не ответили на вопрос'))
            }
            return
          }
          if (this.chosenAnswersList.every((column) => column.list.every((answer) => answer.correctID === column.id))) {
            this.isAnswerChosenCorrect = true
          }
          this.isButtonPressed = true
          resolve(true)
        }
      })
    },
    isAnswerCorrect() {
      try {
        this.all_answers.forEach((el, index) => {
          this.resultsList.push(this.questionsList[index])
          this.resultsList[index]['chosenAnswerIds'] = []
          this.resultsList[index]['number'] = index

          if (this.questionsList[index].answerType === 1) {
            for (let i = 0; i < this.questionsList[index].answersList.length; i++) {
              if (this.questionsList[index].answersList[i].correct && el === 'answer_' + (i + 1)) {
                this.correct_answers++
                this.resultsList[index]['isCorrect'] = true
                this.resultsList[index]['chosenAnswerIds'].push(this.questionsList[index].answersList[i].id)
              } else if (el === 'answer_' + (i + 1)) {
                this.resultsList[index]['chosenAnswerIds'].push(this.questionsList[index].answersList[i].id)
              }
            }
          } else if (this.questionsList[index].answerType === 2) {
            let total_corrects_count = 0
            let current_corrects_count = 0
            for (let a = 0; a < this.questionsList[index].answersList.length; a++) {
              if (this.questionsList[index].answersList[a].correct) {
                total_corrects_count++
                for (let j = 0; j < el.length; j++) {
                  if (el[j] === 'answer_' + (a + 1)) {
                    current_corrects_count++
                    this.resultsList[index]['chosenAnswerIds'].push(this.questionsList[index].answersList[a].id)
                  }
                }
              } else {
                for (let q = 0; q < el.length; q++) {
                  if (el[q] === 'answer_' + (a + 1)) {
                    this.resultsList[index]['chosenAnswerIds'].push(this.questionsList[index].answersList[a].id)
                  }
                }
              }
            }
            if (current_corrects_count === total_corrects_count && el.length === total_corrects_count) {
              this.correct_answers++
              this.resultsList[index]['isCorrect'] = true
            }
          } else if (this.questionsList[index].answerType === 3) {
            this.resultsList[index]['userInput'] = el
            for (let k = 0; k < this.questionsList[index].answersList.length; k++) {
              if (
                this.questionsList[index].answersList[k].text.toUpperCase().replace(/ /g, '') ===
                el.toUpperCase().replace(/ /g, '')
              ) {
                this.correct_answers++
                this.resultsList[index]['isCorrect'] = true
              }
            }
          } else if (this.questionsList[index].answerType === 4) {
            this.resultsList[index]['sequenceList'] = el
            if (
              el.every((finalAnswer, i) => {
                return finalAnswer.correctIndex === i
              })
            ) {
              this.correct_answers++
              this.resultsList[index]['isCorrect'] = true
            }
          } else if (this.questionsList[index].answerType === 5) {
            this.resultsList[index]['firstAnswerlList'] = el.first
            this.resultsList[index]['secondAnswerlList'] = el.second
            if (
              el.first.every((firstAnswer, i) => {
                return firstAnswer.id === el.second[i].id
              })
            ) {
              this.correct_answers++
              this.resultsList[index]['isCorrect'] = true
            }
          } else if (this.questionsList[index].answerType === 6) {
            this.resultsList[index]['trueFalseList'] = el
            if (
              this.questionsList[index].answersList.every((answer, i) => {
                return answer.correctAnswer === el[i]
              })
            ) {
              this.correct_answers++
              this.resultsList[index]['isCorrect'] = true
            }
          } else if (this.questionsList[index].answerType === 7) {
            this.resultsList[index]['columnsAnswersList'] = el
            if (!this.questionsList[index].answersList.length) {
              if (
                el.every((column) => {
                  return column.list.every((answer) => answer.correctID === column.id)
                })
              ) {
                this.correct_answers++
                this.resultsList[index]['isCorrect'] = true
              }
            }
          }
        })
      } catch (e) {
        throw e
      }
    },
    checkMove(e) {
      if (e.to != e.from) {
        return false
      }
      return true
    }
  }
}
</script>
